import ArrowDown from '@/app/_components/ui/icons/ArrowDown.svg';
import Search from '@/app/_components/ui/icons/Search.svg';
import { useState, useEffect } from 'react';
import { useRouterParams } from '@/app/_hooks/useRouterParams';
import { useSearchParams } from 'next/navigation';

export default function CategoryFilters({ Categories, onChange }) {
  const [selectedCategories, setSelectedCategories] = useState([]);
  const { checkExistParams } = useRouterParams();
  const searchParams = useSearchParams();

  useEffect(() => {
    const categories = checkExistParams('category');
    setSelectedCategories([...categories]);
  }, [searchParams]);

  return (
    <div className="p-4 border border-light-gray-400 rounded-md mb-3.5">
      <div className="filterTitle pb-4 flex justify-between">
        <div className="font-bold">دسته بندی </div>
        <ArrowDown />
      </div>
      <div className="searchCategoryFilters relative  mb-2">
        <input
          type="text"
          className="appearance-none text-slate-900 border border-light-gray-200 rounded-md px-8 pl-4 w-full focus:outline-none"
          placeholder="جستجو دسته بندی..."
        />
        <Search className="absolute top-2 right-2" />
      </div>
      <div className="max-h-[300px] custom-scroll-bar overflow-y-auto">
        {Categories.length ? (
          Categories.map((cat, index) => {
            return (
              <div className="w-full flex items-center " key={index}>
                <input
                  type="checkbox"
                  id={cat.id}
                  onChange={onChange}
                  name="category"
                  checked={selectedCategories.some((ca) => ca == cat.id)}
                  className="border border-light-gray-900 rounded-sm ml-3 w-5 h-5"
                />
                <div className="border-b grow border-light-gray-150 py-3.5 text-sm">
                  <label>{cat.title} </label>
                </div>
              </div>
            );
          })
        ) : (
          <></>
        )}
      </div>
    </div>
  );
}
